import { render, staticRenderFns } from "./ActionDropdownEdo.vue?vue&type=template&id=d0ef6510&"
import script from "./ActionDropdownEdo.vue?vue&type=script&lang=ts&"
export * from "./ActionDropdownEdo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
installComponents(component, {VIcon,VListItem})
